// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__Tqn-Y","footer":"ModalCreateQualiphyProcedure_footer__17OJw","additionData":"ModalCreateQualiphyProcedure_additionData__nraEN"};